import type { TutorialSection } from '@/lib/github/types'

export function collectAvailableLanguages(sections: TutorialSection[]): string[] {
  const allLanguages = sections.flatMap((s) => s.languages ?? [])
  return Array.from(new Set(allLanguages))
    .filter((lang) => lang !== 'default')
    .toSorted((a, b) => a.localeCompare(b))
}
